var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"b_botton",class:{disable: _vm.disable},on:{"click":function($event){return _vm.click()}}},[_vm._t("default"),_c('transition',{attrs:{"name":"loading"}},[(!_vm.flag)?_c('div',{staticClass:"loading"},[_c('div',{staticClass:"load_wrap"},[_c('span'),_c('span'),_c('span')])]):_vm._e()])],2)
}
var staticRenderFns = []

export { render, staticRenderFns }